if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;
 
        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }
 
      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }
 
      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');
 
        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);
 
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }
 
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }
 
        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);
 
        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }
 
      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;
 
        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;
 
        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }
 
      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }
 
      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }
 
      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }
 
      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
 
;(function(){
  if (window.__binzyGalleryVariantSync) return;
  window.__binzyGalleryVariantSync = true;
 
  function extractMediaId(raw){
    if(!raw) return null;
    var m = String(raw).match(/(\d+)$/);
    return m ? m[1] : null;
  }
 
  var productCache = {};
  function getProduct(){
    var m = location.pathname.match(/\/products\/([^\/?#]+)/), handle = m ? m[1] : null;
    if(!handle) return Promise.resolve(null);
    return productCache[handle] || (productCache[handle] = fetch('/products/'+handle+'.js').then(function(r){return r.json()}).catch(function(){return null}));
  }
 
  // Lit le texte alternatif d'une image et determine s'il faut "skip" (image valable
  // sur tous les modeles) ou changer de variante (Finition + Couleur detectees).
  function parseAlt(alt){
    if(!alt) return null;
    var s = alt.toLowerCase();
    if (s.indexOf('valable') !== -1) return 'skip';
    var finition = null, couleur = null;
    if (s.indexOf('onyx') !== -1) finition = 'Onyx';
    else if (s.indexOf('inox') !== -1) finition = 'Inox';
    if (s.indexOf('rouge') !== -1) couleur = 'Rouge';
    else if (s.indexOf('noir') !== -1) couleur = 'Noire';
    if (finition && couleur) return { finition: finition, couleur: couleur };
    return null;
  }
 
  function selectVariant(variant, product){
    var vs = document.querySelector('variant-selects');
    if(!vs) return;
    var changedInput = null;
    for(var idx=0; idx<product.options.length; idx++){
      var val = variant['option'+(idx+1)];
      if(val==null) continue;
      var inputs = vs.querySelectorAll('input[type=radio]');
      for(var j=0;j<inputs.length;j++){
        var input = inputs[j];
        if(input.name.indexOf('-'+(idx+1))!==-1 && input.value===val){
          if(!input.checked){ input.checked = true; changedInput = input; }
          break;
        }
      }
    }
    changedInput && changedInput.dispatchEvent(new Event('change', {bubbles:true}));
  }
 
  function applyVariantForMedia(rawMediaId){
    var mediaId = extractMediaId(rawMediaId);
    if(!mediaId) return;
    getProduct().then(function(product){
      if(!product) return;
      var variant = null;
      for(var i=0;i<product.variants.length;i++){
        var v = product.variants[i];
        if(v.featured_media && String(v.featured_media.id)===mediaId){ variant = v; break; }
      }
      if(!variant) return;
      selectVariant(variant, product);
    });
  }
 
  // Point d'entree principal : priorite au texte alternatif de l'image cliquee/affichee.
  // - alt contient "valable" -> ne touche pas a la variante en cours (skip)
  // - alt donne Finition+Couleur -> selectionne cette variante
  // - sinon -> repli sur l'ancienne methode (featured_media.id)
  function applyVariantForAltOrMedia(alt, rawMediaId){
    var parsed = parseAlt(alt);
    if (parsed === 'skip') return;
    if (parsed) {
      getProduct().then(function(product){
        if(!product) return;
        var variant = null;
        for(var i=0;i<product.variants.length;i++){
          var v = product.variants[i];
          var bzMap={edelstahl:'Inox',rot:'Rouge',schwarz:'Noire'}, bzO1=bzMap[String(v.option1).toLowerCase()]||v.option1, bzO2=bzMap[String(v.option2).toLowerCase()]||v.option2; if(bzO1===parsed.finition && bzO2===parsed.couleur){ variant = v; break; }
        }
        if(variant){ selectVariant(variant, product); return; }
        applyVariantForMedia(rawMediaId);
      });
      return;
    }
    applyVariantForMedia(rawMediaId);
  }
 
  function getAltFromElement(el){
    if(!el) return null;
    var img = el.querySelector ? el.querySelector('img') : null;
    return img ? (img.getAttribute('data-alt-fr') || img.getAttribute('alt')) : null;
  }
 
  document.addEventListener('click', function(e){
    var btn = e.target.closest('media-gallery button');
    if(!btn) return;
    var raw = btn.getAttribute('data-media-id');
    var wrap = btn.closest('[data-target],[data-media-id]');
    if(!raw && wrap) raw = wrap.getAttribute('data-target') || wrap.getAttribute('data-media-id');
    var alt = getAltFromElement(wrap) || getAltFromElement(btn);
    if(raw || alt) applyVariantForAltOrMedia(alt, raw);
  });
 
  function bindSliders(){
    document.querySelectorAll('media-gallery [id^="GalleryViewer"]').forEach(function(viewer){
      if(viewer.__binzyBound) return;
      viewer.__binzyBound = true;
      viewer.addEventListener('slideChanged', function(e){
        var el = e.detail ? e.detail.currentElement : null;
        var id = el && el.dataset ? el.dataset.mediaId : null;
        var innerEl = el;
        if(!id && el && el.querySelector){
          var inner = el.querySelector('[data-media-id]');
          id = inner ? inner.dataset.mediaId : null;
          innerEl = inner || el;
        }
        var alt = getAltFromElement(el) || getAltFromElement(innerEl);
        if(id || alt) applyVariantForAltOrMedia(alt, id);
      });
    });
  }
  bindSliders();
  document.addEventListener('shopify:section:load', bindSliders);
})();
(function () {
  if (window.__binzySlideGuard) return;
  window.__binzySlideGuard = true;
 
  var lastGesture = 0;        // dernier doigt/souris posé sur la galerie
  var lastVariantChange = 0;  // dernier changement de variante
  var GESTURE_MS = 4000;      // durée pendant laquelle un geste reste "valide"
  var LOCK_MS = 1500;         // verrou après un changement de variante
 
  function markGesture(e) {
    var t = e.target;
    if (t && t.closest && t.closest('media-gallery')) lastGesture = Date.now();
  }
 
  ['pointerdown', 'touchstart', 'touchmove', 'mousedown'].forEach(function (ev) {
    document.addEventListener(ev, markGesture, true);
  });
 
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.tagName === 'INPUT' && t.closest && t.closest('variant-selects')) {
      lastVariantChange = Date.now();
    }
  }, true);
 
  document.addEventListener('slideChanged', function (e) {
    var now = Date.now();
    if (now - lastVariantChange < LOCK_MS || now - lastGesture > GESTURE_MS) {
      e.stopPropagation();
    }
  }, true);
})();
 (function () {
  if (window.__binzySlideGuard) return;
  window.__binzySlideGuard = true;
 
  var lastGesture = 0;        // dernier doigt/souris posé sur la galerie
  var lastVariantChange = 0;  // dernier changement de variante
  var GESTURE_MS = 4000;      // durée pendant laquelle un geste reste "valide"
  var LOCK_MS = 1500;         // verrou après un changement de variante
 
  function markGesture(e) {
    var t = e.target;
    if (t && t.closest && t.closest('media-gallery')) lastGesture = Date.now();
  }
 
  ['pointerdown', 'touchstart', 'touchmove', 'mousedown'].forEach(function (ev) {
    document.addEventListener(ev, markGesture, true);
  });
 
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.tagName === 'INPUT' && t.closest && t.closest('variant-selects')) {
      lastVariantChange = Date.now();
    }
  }, true);
 
  document.addEventListener('slideChanged', function (e) {
    var now = Date.now();
    if (now - lastVariantChange < LOCK_MS || now - lastGesture > GESTURE_MS) {
      e.stopPropagation();
    }
  }, true);
})();
(function () {
  if (window.__binzySlideGuard) return;
  window.__binzySlideGuard = true;
 
  var lastGesture = 0;        // dernier doigt/souris posé sur la galerie
  var lastVariantChange = 0;  // dernier changement de variante
  var GESTURE_MS = 4000;      // durée pendant laquelle un geste reste "valide"
  var LOCK_MS = 1500;         // verrou après un changement de variante
 
  function markGesture(e) {
    var t = e.target;
    if (t && t.closest && t.closest('media-gallery')) lastGesture = Date.now();
  }
 
  ['pointerdown', 'touchstart', 'touchmove', 'mousedown'].forEach(function (ev) {
    document.addEventListener(ev, markGesture, true);
  });
 
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.tagName === 'INPUT' && t.closest && t.closest('variant-selects')) {
      lastVariantChange = Date.now();
    }
  }, true);
 
  document.addEventListener('slideChanged', function (e) {
    var now = Date.now();
    if (now - lastVariantChange < LOCK_MS || now - lastGesture > GESTURE_MS) {
      e.stopPropagation();
    }
  }, true);
})(); 
/* BINZY CORRECTIF 2 - carrousel + prix du bandeau - v2 */
(function () {
  if (window.__binzyKeepChosenPhoto) return;
  window.__binzyKeepChosenPhoto = true;
  var chosenId = null, chosenAt = 0, armed = 0, lastVariantChange = 0;
  var CHOICE_MS = 3000, ARM_MS = 2500, FREEZE_MS = 3000;

  function remember(node) {
    if (!node || !node.closest) return;
    var el = node.closest('[data-media-id]') || node.closest('[data-target]');
    if (!el) return;
    var id = el.getAttribute('data-media-id') || el.getAttribute('data-target');
    if (id) { chosenId = id; chosenAt = Date.now(); }
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('media-gallery')) remember(e.target);
  }, true);

  document.addEventListener('slideChanged', function (e) {
    if (Date.now() - lastVariantChange < FREEZE_MS) { e.stopPropagation(); return; }
    var el = e.detail && e.detail.currentElement;
    if (!el) return;
    var id = el.dataset ? el.dataset.mediaId : null;
    if (!id && el.querySelector) {
      var inner = el.querySelector('[data-media-id]');
      id = inner ? inner.dataset.mediaId : null;
    }
    if (id) { chosenId = id; chosenAt = Date.now(); }
  }, true);

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || t.tagName !== 'INPUT' || !t.closest || !t.closest('variant-selects')) return;
    lastVariantChange = Date.now();
    if (e.isTrusted) armed = 0;
    else if (chosenId && Date.now() - chosenAt < CHOICE_MS) armed = Date.now();
  }, true);

  var PI = customElements.get('product-info');
  if (PI && PI.prototype && !PI.prototype.__binzyKeepPatched) {
    PI.prototype.__binzyKeepPatched = true;
    var origUpdateMedia = PI.prototype.updateMedia;
    PI.prototype.updateMedia = function (html, featuredId) {
      if (armed && Date.now() - armed < ARM_MS && chosenId) {
        var gallery = this.querySelector('media-gallery');
        if (gallery && gallery.setActiveMedia) gallery.setActiveMedia(chosenId, false);
        return;
      }
      return origUpdateMedia.apply(this, arguments);
    };
  }
})();

(function () {
  if (window.__binzyStickyPrice) return;
  window.__binzyStickyPrice = true;

  function readPrice(root) {
    var sale = root.querySelector('.price__sale');
    if (sale && sale.offsetParent !== null) {
      var s = sale.querySelector('.price-item--sale');
      if (s && s.textContent.trim()) return s.textContent.trim();
    }
    var r = root.querySelector('.price__regular .price-item--regular');
    return r && r.textContent.trim() ? r.textContent.trim() : null;
  }

  function sync() {
    var source = document.querySelector('[id^="price-"]');
    var target = document.querySelector('.sticky-atc .current-price');
    if (!source || !target) return false;
    var value = readPrice(source);
    if (value && target.textContent.trim() !== value) target.textContent = value;
    return true;
  }

  function start() {
    var source = document.querySelector('[id^="price-"]');
    if (!source) return false;
    sync();
    new MutationObserver(sync).observe(source, { childList: true, subtree: true, characterData: true });
    return true;
  }

  function boot() {
    if (start()) return;
    var tries = 0;
    var timer = setInterval(function () { if (start() || ++tries > 20) clearInterval(timer); }, 300);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
(function () {
  if (window.__binzyVariantTitle) return;
  window.__binzyVariantTitle = true;
 
  function label() {
    var vals = [].slice.call(document.querySelectorAll('variant-selects input[type=radio]'))
      .filter(function (i) { return i.checked; })
      .map(function (i) { return i.value; });
    var finition = null, couleur = null;
    vals.forEach(function (v) {
      if (/onyx/i.test(v)) finition = 'ONYX';
      else if (/inox/i.test(v)) finition = 'INOX';
      else if (/rouge/i.test(v)) couleur = 'rouge';
      else if (/noir/i.test(v)) couleur = 'noire';
    });
    if (!finition || !couleur) return null;
    return 'BINZY - ' + finition + ' poignée ' + couleur;
  }
 
  function apply() {
    var txt = label();
    if (!txt) return;
    var h1 = document.querySelector('.product__title h1');
    if (h1 && h1.textContent.trim() !== txt) h1.textContent = txt;
    var sticky = document.querySelector('.sticky-atc__title');
    if (sticky && sticky.textContent.trim() !== txt) sticky.textContent = txt;
  }
 
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || t.tagName !== 'INPUT' || !t.closest || !t.closest('variant-selects')) return;
    apply();
    setTimeout(apply, 600);
    setTimeout(apply, 1500);
  }, true);
 
  apply();
  setTimeout(apply, 500);
  document.addEventListener('DOMContentLoaded', apply);
})();